import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 7.03546L15 12.0355L10 17.0355", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretRight);
const Memo = memo(ForwardRef);
export default Memo;
